/**
 * @generated SignedSource<<3229bf6440fcb742603ce10afa549980>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useProfessionalDashboardQuery$variables = {
  count: number;
  cursor?: string | null | undefined;
  includePast: boolean;
  userId: string;
};
export type useProfessionalDashboardQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useProfessionalDashboardPast_query" | "useProfessionalDashboardUpcoming_query">;
};
export type useProfessionalDashboardQuery = {
  response: useProfessionalDashboardQuery$data;
  variables: useProfessionalDashboardQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "count"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cursor"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includePast"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v4 = {
  "kind": "Variable",
  "name": "count",
  "variableName": "count"
},
v5 = {
  "kind": "Variable",
  "name": "cursor",
  "variableName": "cursor"
},
v6 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v7 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "cursor"
},
v8 = {
  "fields": [
    (v6/*: any*/)
  ],
  "kind": "ObjectValue",
  "name": "filterBy"
},
v9 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "count"
},
v10 = {
  "kind": "Literal",
  "name": "include",
  "value": {
    "cancelled": true
  }
},
v11 = [
  (v7/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/),
  {
    "kind": "Literal",
    "name": "only",
    "value": "UPCOMING"
  },
  {
    "kind": "Literal",
    "name": "sortBy",
    "value": {
      "scheduledDate": "ASC"
    }
  }
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDate",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cancelledByName",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cancelledById",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "language",
  "storageKey": null
},
v20 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v13/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "checkoutUrl",
          "storageKey": null
        },
        (v14/*: any*/),
        (v15/*: any*/),
        (v16/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "employee",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "surname",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "UserSettings",
              "kind": "LinkedField",
              "name": "settings",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasGivenSessionSummarisationConsent",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            (v13/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SessionAppointment",
          "kind": "LinkedField",
          "name": "appointment",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rescheduledPreviousStartDate",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v17/*: any*/),
        (v18/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "AutomatedSessionSummary",
          "kind": "LinkedField",
          "name": "automatedSummary",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "summary",
              "plural": false,
              "selections": [
                (v12/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v19/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "transcriptionStatus",
          "storageKey": null
        }
      ],
      "type": "Session",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v13/*: any*/),
        (v14/*: any*/),
        (v15/*: any*/),
        (v16/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Workshop",
          "kind": "LinkedField",
          "name": "workshop",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "illustrationCard",
              "storageKey": null
            },
            (v13/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "participants",
          "plural": true,
          "selections": [
            (v13/*: any*/)
          ],
          "storageKey": null
        },
        (v17/*: any*/),
        (v18/*: any*/),
        (v19/*: any*/)
      ],
      "type": "GroupSession",
      "abstractKey": null
    }
  ],
  "type": "SessionResponse",
  "abstractKey": "__isSessionResponse"
},
v21 = [
  (v13/*: any*/),
  (v14/*: any*/),
  (v16/*: any*/)
],
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v24 = [
  "filterBy",
  "include",
  "only",
  "sortBy"
],
v25 = [
  (v7/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/),
  {
    "kind": "Literal",
    "name": "only",
    "value": "PAST"
  },
  {
    "kind": "Literal",
    "name": "sortBy",
    "value": {
      "scheduledDate": "DESC"
    }
  }
],
v26 = [
  (v13/*: any*/),
  (v14/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useProfessionalDashboardQuery",
    "selections": [
      {
        "args": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "useProfessionalDashboardUpcoming_query"
      },
      {
        "args": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "kind": "Variable",
            "name": "includePast",
            "variableName": "includePast"
          },
          (v6/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "useProfessionalDashboardPast_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "useProfessionalDashboardQuery",
    "selections": [
      {
        "alias": "upcoming",
        "args": (v11/*: any*/),
        "concreteType": "SessionsResponseConnection",
        "kind": "LinkedField",
        "name": "sessions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SessionsResponseEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v20/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": (v21/*: any*/),
                    "type": "Session",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v21/*: any*/),
                    "type": "GroupSession",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v22/*: any*/)
            ],
            "storageKey": null
          },
          (v23/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "upcoming",
        "args": (v11/*: any*/),
        "filters": (v24/*: any*/),
        "handle": "connection",
        "key": "ProfessionalDashboard_upcoming",
        "kind": "LinkedHandle",
        "name": "sessions"
      },
      {
        "condition": "includePast",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "past",
            "args": (v25/*: any*/),
            "concreteType": "SessionsResponseConnection",
            "kind": "LinkedField",
            "name": "sessions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SessionsResponseEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v20/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v26/*: any*/),
                        "type": "Session",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v26/*: any*/),
                        "type": "GroupSession",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v22/*: any*/)
                ],
                "storageKey": null
              },
              (v23/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "past",
            "args": (v25/*: any*/),
            "filters": (v24/*: any*/),
            "handle": "connection",
            "key": "ProfessionalDashboard_past",
            "kind": "LinkedHandle",
            "name": "sessions"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "9f80b50d1985fe8aaec3107c98aa4577",
    "id": null,
    "metadata": {},
    "name": "useProfessionalDashboardQuery",
    "operationKind": "query",
    "text": "query useProfessionalDashboardQuery(\n  $userId: String!\n  $includePast: Boolean!\n  $count: Int!\n  $cursor: String\n) {\n  ...useProfessionalDashboardUpcoming_query_2PpJm0\n  ...useProfessionalDashboardPast_query_WxL5y\n}\n\nfragment useProfessionalDashboardPast_query_WxL5y on Query {\n  past: sessions(filterBy: {userId: $userId}, include: {cancelled: true}, only: PAST, sortBy: {scheduledDate: DESC}, first: $count, after: $cursor) @include(if: $includePast) {\n    edges {\n      node {\n        __typename\n        ...useProfessionalSessionCard_fragment\n        ... on Session {\n          id\n          status\n        }\n        ... on GroupSession {\n          id\n          status\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment useProfessionalDashboardUpcoming_query_2PpJm0 on Query {\n  upcoming: sessions(filterBy: {userId: $userId}, include: {cancelled: true}, only: UPCOMING, sortBy: {scheduledDate: ASC}, first: $count, after: $cursor) {\n    edges {\n      node {\n        __typename\n        ...useProfessionalSessionCard_fragment\n        ... on Session {\n          id\n          status\n          startDate\n        }\n        ... on GroupSession {\n          id\n          status\n          startDate\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment useProfessionalSessionCard_fragment on SessionResponse {\n  __isSessionResponse: __typename\n  __typename\n  ... on Session {\n    id\n    type\n    checkoutUrl\n    status\n    endDate\n    startDate\n    employee {\n      name\n      surname\n      settings {\n        hasGivenSessionSummarisationConsent\n      }\n      id\n    }\n    appointment {\n      rescheduledPreviousStartDate\n    }\n    cancelledByName\n    cancelledById\n    automatedSummary {\n      summary {\n        __typename\n        ... on ProcessedProfessionalSessionSummary {\n          __typename\n        }\n      }\n    }\n    language\n    transcriptionStatus\n  }\n  ... on GroupSession {\n    id\n    status\n    endDate\n    startDate\n    workshop {\n      title\n      illustrationCard\n      id\n    }\n    participants {\n      id\n    }\n    cancelledByName\n    cancelledById\n    language\n  }\n}\n"
  }
};
})();

(node as any).hash = "ead51a5a39334e57d6603d9d60a2aeee";

export default node;
